// Auto-generated from products.csv
export const productsData = [
  {
    "id": "1",
    "sku": "15031",
    "notes": "Uncoated 8-well strip plate for colorimetric detection"
  },
  {
    "id": "2",
    "sku": "15042",
    "notes": "Uncoated 96-well plate for chemiluminescent detection"
  },
  {
    "id": "3",
    "sku": "15100",
    "notes": "Clear 8-well strip plate - activated maleic anhydride will bind amine functional groups to the plate"
  },
  {
    "id": "4",
    "sku": "15110",
    "notes": "Clear 96-well plate - activated maleic anhydride will bind amine functional groups to the plate"
  },
  {
    "id": "5",
    "sku": "15116",
    "notes": "NeutrAvidin-treated plates minimize background when the target is in high abundance"
  },
  {
    "id": "6",
    "sku": "15117",
    "notes": "NeutrAvidin-treated plates minimize background when the target is in high abundance"
  },
  {
    "id": "7",
    "sku": "15118",
    "notes": "White plate for chemiluminescent detection capable of binding biotinylated molecules"
  },
  {
    "id": "8",
    "sku": "15119",
    "notes": "Black plate for fluorescent detection capable of binding biotinylated molecules"
  },
  {
    "id": "9",
    "sku": "15120",
    "notes": "8-well strip plate for colorimetric detection capable of binding biotinylated molecules"
  },
  {
    "id": "10",
    "sku": "15147",
    "notes": "White, copper-treated plate for chemiluminescent detection"
  },
  {
    "id": "11",
    "sku": "15148",
    "notes": "Black, copper-treated plate for fluorescent detection"
  },
  {
    "id": "12",
    "sku": "15152",
    "notes": "White plate for chemiluminescent detection capable of binding a sulfhydryl functional group"
  },
  {
    "id": "13",
    "sku": "15153",
    "notes": "Black plate for fluorescent detection capable of binding a sulfhydryl functional group"
  },
  {
    "id": "14",
    "sku": "15240",
    "notes": "White plate for chemiluminescent detection capable of binding a GST-tagged molecule"
  },
  {
    "id": "15",
    "sku": "15242",
    "notes": "White, nickel-treated plate for chemiluminescent detection"
  },
  {
    "id": "16",
    "sku": "15401",
    "notes": "NeutrAvidin-treated plates minimize background when the target is in high abundance"
  },
  {
    "id": "17",
    "sku": "15505",
    "notes": "White, 384-well plate for chemiluminescent detection capable of binding biotinylated molecules"
  },
  {
    "id": "18",
    "sku": "15041",
    "notes": "Uncoated 96-well plate for colorimetric detection"
  },
  {
    "id": "19",
    "sku": "15124",
    "notes": "Clear 96-well plate for colorimetric detection capable of binding biotinylated molecules"
  },
  {
    "id": "20",
    "sku": "15127",
    "notes": "NeutrAvidin-treated plates minimize background when the target is in high abundance"
  },
  {
    "id": "21",
    "sku": "15129",
    "notes": "NeutrAvidin-treated plates minimize background when the target is in high abundance"
  },
  {
    "id": "22",
    "sku": "15134",
    "notes": "Clear plate for colorimetric detection capable of binding mouse IgG"
  },
  {
    "id": "23",
    "sku": "15140",
    "notes": "Clear plate for colorimetric detection capable of binding a GST-tagged molecule"
  },
  {
    "id": "24",
    "sku": "15142",
    "notes": "Clear, nickel-treated plate for colorimetric detection"
  },
  {
    "id": "25",
    "sku": "15143",
    "notes": "Clear, copper-treated plate for colorimetric detection"
  },
  {
    "id": "26",
    "sku": "15146",
    "notes": "Clear, copper-treated, 8-well strip plate for colorimetric detection"
  },
  {
    "id": "27",
    "sku": "15150",
    "notes": "Clear plate for colorimetric detection capable of binding a sulfhydryl functional group"
  },
  {
    "id": "28",
    "sku": "15340",
    "notes": "Black plate for fluorescent detection capable of binding a GST-tagged molecule"
  },
  {
    "id": "29",
    "sku": "15342",
    "notes": "Black, nickel-treated plate for fluorescent detection"
  },
  {
    "id": "30",
    "sku": "15400",
    "notes": "NeutrAvidin-treated plates minimize background when the target is in high abundance"
  },
  {
    "id": "31",
    "sku": "15402",
    "notes": "NeutrAvidin-treated plates minimize background when the target is in high abundance"
  },
  {
    "id": "32",
    "sku": "15405",
    "notes": "Clear, 384-well plate for colorimetric detection capable of binding biotinylated molecules"
  },
  {
    "id": "33",
    "sku": "15407",
    "notes": "Black, 384-well plate for fluorescent detection capable of binding biotinylated molecules"
  },
  {
    "id": "34",
    "sku": "15442",
    "notes": "Nickel-treated plate for colorimetric detection"
  },
  {
    "id": "35",
    "sku": "15500",
    "notes": "High capacity plate intended to increase sensitivity for low abundance analytes"
  },
  {
    "id": "36",
    "sku": "15501",
    "notes": "High capacity plate intended to increase sensitivity for low abundance analytes"
  },
  {
    "id": "37",
    "sku": "15502",
    "notes": "High capacity plate intended to increase sensitivity for low abundance analytes"
  },
  {
    "id": "38",
    "sku": "15503",
    "notes": "High capacity plate intended to increase sensitivity for low abundance analytes"
  },
  {
    "id": "39",
    "sku": "15504",
    "notes": "High capacity plate intended to increase sensitivity for low abundance analytes"
  },
  {
    "id": "40",
    "sku": "15506",
    "notes": "High capacity plate intended to increase sensitivity for low abundance analytes"
  },
  {
    "id": "41",
    "sku": "15525",
    "notes": "Black, 8-well strip plate for fluorescent detection capable of binding biotinylated molecules"
  },
  {
    "id": "42",
    "sku": "437111",
    "notes": "Black, uncoated, 96-well plate for fluorescent detection"
  },
  {
    "id": "43",
    "sku": "446471",
    "notes": "Black, uncoated, 8-well strip plate for fluorescent detection"
  },
  {
    "id": "44",
    "sku": "460372",
    "notes": "White, uncoated, 384-well plate for chemiluminescent detection"
  },
  {
    "id": "45",
    "sku": "460518",
    "notes": "Black, uncoated, 384-well plate for fluorescent detection"
  },
  {
    "id": "46",
    "sku": "463201",
    "notes": "White, uncoated, 8-well strip plate for chemiluminescent detection"
  },
  {
    "id": "47",
    "sku": "464718",
    "notes": "Clear, uncoated, 384-well plate for colorimetric detection"
  },
  {
    "id": "48",
    "sku": "28360",
    "notes": "Compatible with HRP and AP enzymes"
  },
  {
    "id": "49",
    "sku": "37535",
    "notes": "High performance blocking buffer for uncoated plates"
  },
  {
    "id": "50",
    "sku": "21130",
    "notes": "HRP-conjugated streptavidin amplifies the signal of biotinylated detection antibodies"
  },
  {
    "id": "51",
    "sku": "21140",
    "notes": "Streptavidin Poly-HRP will maximize sensitivity for low abundance analytes"
  },
  {
    "id": "52",
    "sku": "S921",
    "notes": "AP-conjugated streptavidin amplifies the signal of biotinylated detection antibodies"
  },
  {
    "id": "53",
    "sku": "15169",
    "notes": "HRP-activated fluorescent substrate"
  },
  {
    "id": "54",
    "sku": "34022",
    "notes": "HRP-activated colorimetric substrate"
  },
  {
    "id": "55",
    "sku": "34024",
    "notes": "This TMB substrate develops slowly to avoid signal saturation for high abundance analytes"
  },
  {
    "id": "56",
    "sku": "34028",
    "notes": "TMB substrates offer high sensitivity for low abundance analytes"
  },
  {
    "id": "57",
    "sku": "37070",
    "notes": "HRP-activated chemiluminescent substrate"
  },
  {
    "id": "58",
    "sku": "37075",
    "notes": "High sensitivity for low abundance analytes"
  },
  {
    "id": "59",
    "sku": "37621",
    "notes": "AP-activated colorimetric substrate"
  },
  {
    "id": "60",
    "sku": "T2214",
    "notes": "AP-activated chemiluminescent substrate"
  },
  {
    "id": "61",
    "sku": "T2216",
    "notes": "High sensitivity for low abundance analytes"
  },
  {
    "id": "62",
    "sku": "N600",
    "notes": "Stop solution stops the TMB substrate reaction."
  },
  {
    "id": "63",
    "sku": "15075",
    "notes": "Convenient format is compatible with multichannel pipettes"
  },
  {
    "id": "64",
    "sku": "15036",
    "notes": "Protects the plate during incubation periods"
  },
  {
    "id": "65",
    "sku": "n/a",
    "notes": "None"
  },
  {
    "id": "66",
    "sku": "n/a",
    "notes": "None"
  },
  {
    "id": "67",
    "sku": "28382",
    "notes": "None"
  },
  {
    "id": "68",
    "sku": "37520",
    "notes": "None"
  },
  {
    "id": "69",
    "sku": "CB01100",
    "notes": "None"
  },
  {
    "id": "70",
    "sku": "CNB0011",
    "notes": "None"
  },
  {
    "id": "71",
    "sku": "28348",
    "notes": "None"
  },
  {
    "id": "72",
    "sku": "28358",
    "notes": "None"
  },
  {
    "id": "73",
    "sku": "37570",
    "notes": "None"
  }
];
